// src/pages/ChatBot/shared/Tag.tsx
//
// Shared tag/chip chassis for the Manage Chat console. Reproduces the
// Documents tab's luggage-tag shape (clip-path arrow + punched hole), size,
// and typography as one visual chassis, parameterized only by a colour `tone`
// (text + background tint). Used for document role chips, query-log status
// pills, and flag chips so every chip across the console reads as one family.

import type { ReactNode } from 'react';
import './Tag.css';

// A tone is a text-colour + background-tint pair, each defined as a class in
// Tag.css. `brass`/`open` are the Documents role chips; the rest carry the
// query-log status and flag semantics (green = answered, amber =
// unanswered/warning, orange = incorrect, blue = custom/override, red = error,
// neutral = other flags).
export type TagTone =
  | 'brass'
  | 'open'
  | 'green'
  | 'amber'
  | 'orange'
  | 'blue'
  | 'red'
  | 'neutral';

interface TagProps {
  tone: TagTone;
  children: ReactNode;
  title?: string;
  className?: string;
}

export default function Tag({ tone, children, title, className }: TagProps) {
  const classes = `tag tag-${tone}${className ? ` ${className}` : ''}`;
  return (
    <span className={classes} title={title}>
      {children}
    </span>
  );
}
